// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"e49d4eb1","149":"5ced2c3f","236":"05222f74","354":"38a7b37c","443":"3e705f1b","678":"0b6bd959","689":"d8785268","724":"1edbc594","728":"fe34ded5","858":"ca76965c","883":"8a5b207a","967":"e4f3f3b1"}[chunkId] + ".chunk.js";
};